import React, { ReactNode, JSX } from 'react';
import { Row } from 'reactstrap';
import { CustomFormComponentsType, FormConfig, FormElement } from '../types/types';
import ElementRenderer from './ElementRenderer';

interface Props {
  elements: FormElement[];
  keySuffix?: FormConfig['keySuffix'];
  externalData?: Record<string, unknown>;
  children?: ReactNode | ReactNode[];
  CustomFormComponents?: CustomFormComponentsType;
}

const RowCreator = (props: Props): JSX.Element => {
  const { elements, keySuffix, externalData, children, CustomFormComponents } = props;

  return (
    <Row className="row-creator">
      {elements.length > 0 &&
        elements.map(element => (
          <ElementRenderer
            key={element.key}
            element={element}
            CustomFormComponents={CustomFormComponents}
            keySuffix={keySuffix}
            externalData={externalData}
            // eslint-disable-next-line react/no-children-prop
            children={children}
          />
        ))}
    </Row>
  );
};

export default RowCreator;
